module.exports = __webpack_public_path__ + "static/media/5hwi2.ac8090c7.png";